
import { fetchCardComments } from './cardComments';
import { fetchPollComments } from './pollComments';
import { fetchCommentReplies } from './commentReplies';
import { CommentWithVotes, CommentSortOption, ContentType } from '../types';

interface FetchCommentsParams {
  contentId: string;
  limit?: number;
  contentType?: ContentType;
  sortBy?: CommentSortOption;
  parentId?: string | null;
  filterBy?: string;
}

interface FetchRepliesParams {
  contentId: string;
  contentType?: ContentType;
  parentId: string;
  limit?: number;
  sortBy?: CommentSortOption;
}

/**
 * Unified function to fetch comments for either polls or cards
 */
export const fetchComments = async (params: FetchCommentsParams) => {
  const { contentId, limit = 50, contentType = 'card', sortBy = 'newest', parentId = null } = params;

  try {
    console.log(`fetchComments: Fetching ${contentType} comments for ID ${contentId} with limit ${limit}, sorted by ${sortBy}, parentId: ${parentId}`);
    
    if (!contentId) {
      console.warn('fetchComments called without contentId');
      return { data: [], error: null };
    }
    
    if (contentType === 'poll') {
      const data = await fetchPollComments(contentId, limit, sortBy, parentId);
      console.log(`fetchComments: Retrieved ${data.length} poll comments`);
      return {
        data,
        error: null
      };
    } else {
      const data = await fetchCardComments(contentId, limit, sortBy, parentId);
      console.log(`fetchComments: Retrieved ${data.length} card comments`);
      return {
        data,
        error: null
      };
    }
  } catch (error) {
    console.error(`Error in fetchComments (${contentType}):`, error);
    return {
      data: [],
      error: error instanceof Error ? error.message : String(error)
    };
  }
};

/**
 * Fetch replies for a comment
 */
export const fetchReplies = async (params: FetchRepliesParams) => {
  const { contentId, parentId, limit = 5, contentType = 'poll', sortBy = 'newest' } = params;
  
  try {
    if (!parentId) {
      return { data: [], error: null };
    }
    
    const data = await fetchCommentReplies(parentId, contentType, limit, sortBy);
    return {
      data,
      error: null
    };
  } catch (error) {
    console.error(`Error fetching replies for comment ${parentId}:`, error);
    return {
      data: [],
      error: error instanceof Error ? error.message : String(error)
    };
  }
};

// Export individual functions
export { fetchCardComments, fetchPollComments, fetchCommentReplies };
